import React from "react";
import PT from "prop-types";
import isEqual from "lodash/isEqual";
import get from "lodash/get";

import { ResponsiveSource, ResponsiveImage } from "@quintype/components";

import PhotoIcon from "../icons/photo";

import "./responsive-source-image.m.css";

const ResponsiveSourceImage = ({
  story,
  desktopAspectRation,
  mobileAspectRation,
  desktopWidths = [250, 480, 640],
  mobileWidths = [250, 480, 640]
}) => {
  const getAspectRatioStyleName = (desktopRatio, mobileRatio) => {
    if (isEqual(desktopRatio, [16, 9]) && isEqual(mobileRatio, [4, 3])) {
      return "responsive-imagex1";
    } else if (isEqual(desktopRatio, [1, 1]) && isEqual(mobileRatio, [4, 3])) {
      return "responsive-imagex2";
    } else if (isEqual(desktopRatio, [267, 332]) && isEqual(mobileRatio, [16, 9])) {
      return "responsive-imagex3";
    } else if (isEqual(desktopRatio, [16, 9]) && isEqual(mobileRatio, [1, 1])) {
      return "responsive-imagex4";
    }
  };

  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);

  return (
    <figure styleName={getAspectRatioStyleName(desktopAspectRation, mobileAspectRation)} className="responsive-image">
      <picture styleName="picture">
        {/* Desktop Version */}
        <ResponsiveSource
          media="(min-width: 1024px)"
          slug={storyImageSlug}
          metadata={story["hero-image-metadata"]}
          aspectRatio={desktopAspectRation}
          widths={desktopWidths}
          sizes="23vw"
          styleName="image"
          src="false"
        />

        {/* Mobile Version */}
        <ResponsiveImage
          slug={storyImageSlug}
          metadata={story["hero-image-metadata"]}
          alt={story["headline"]}
          aspectRatio={mobileAspectRation}
          defaultWidth={480}
          widths={mobileWidths}
          styleName="image"
          sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 23vw"
          src="false"
        />
      </picture>
      {story["story-template"] === "photo" && (
        <div styleName="photo-icon">
          {" "}
          <PhotoIcon />{" "}
        </div>
      )}
    </figure>
  );
};

ResponsiveSourceImage.defaultProps = {
  desktopAspectRation: [16, 9],
  mobileAspectRation: [4, 3]
};

ResponsiveSourceImage.propTypes = {
  story: PT.object,
  desktopAspectRation: PT.array,
  mobileAspectRation: PT.array,
  desktopWidths: PT.array,
  mobileWidths: PT.array
};

export default ResponsiveSourceImage;
